import React, { SetStateAction } from 'react'
import { useTranslation } from 'react-i18next'
import { Avatar, Box, Button, Combobox, ComboboxItem, Input } from '@node-space/ui-components'
import { useCryptoCurrenciesQuery } from 'hooks/queries'

type CryptoFilterBarProps = {
  searchTerm: string
  onSearchTermChange: React.Dispatch<SetStateAction<string>>
  searchCurrency: string
  onSearchCurrencyChange: React.Dispatch<SetStateAction<string>>
  isBeingSearched: boolean
  isFetchingCryptoAddresses: boolean
}

const CryptoFilterBar = ({
  searchTerm,
  onSearchTermChange,
  onSearchCurrencyChange,
  searchCurrency,
  isBeingSearched,
  isFetchingCryptoAddresses,
}: CryptoFilterBarProps) => {
  const { t } = useTranslation()
  const { data: cryptoCurrencies, isPending: isLoadingCrypto } = useCryptoCurrenciesQuery()

  const options: ComboboxItem[] =
    cryptoCurrencies?.map(({ code, name }) => {
      return {
        LeftElement: <Avatar name={code.toLowerCase()} size="small" />,
        leftText: name,
        value: code,
      }
    }) ?? []

  return (
    <Box flex gapX={12} gapY={32} paddingT={4}>
      <Box className="w-1/2 mt-1">
        <Input
          testId="filter-search-field"
          placeholderText={t('manageCryptoAddresses.searchPlaceholder')}
          onChange={event => onSearchTermChange(event.target.value)}
          value={searchTerm || ''}
        />
      </Box>
      <Box className="block mr-3 mb-8 w-1/5">
        <Combobox
          id="select-currency"
          defaultValue={searchCurrency || ''}
          onChange={value => {
            onSearchCurrencyChange(value)
          }}
          items={options}
          searchPlaceholder={t('currency')}
          disabled={isLoadingCrypto}
        />
      </Box>
      {isBeingSearched && !isFetchingCryptoAddresses && (
        <Box flex centerChildren className="mb-8">
          <Button
            variant="ghost"
            onClick={() => {
              onSearchTermChange('')
              onSearchCurrencyChange('')
            }}
          >
            {t('clearFilters')}
          </Button>
        </Box>
      )}
    </Box>
  )
}

export default CryptoFilterBar
